import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { BuyerData, Cart } from '../../../../core/model';
import { Occ } from '../../../../core/occ';
import { ConverterService } from '../../../../core/util';
import { BUYER_DATA_NORMALIZER, CART_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class CartConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  load(userId: string, cartId: string): Observable<Cart> {
    const url = this.occEndpointsService.buildUrl('carts', { urlParams: { userId: userId, cartCodeOrType: cartId } });
    return this.httpClient.get<Occ.Cart>(url).pipe(this.converterService.pipeable(CART_NORMALIZER));
  }

  buyerData(userId: string, cartId: string): Observable<BuyerData> {
    const url = this.occEndpointsService.buildUrl('buyerData', { urlParams: { userId: userId, cartCodeOrType: cartId } });
    return this.httpClient.get(url).pipe(this.converterService.pipeable(BUYER_DATA_NORMALIZER));
  }
}
